import { Component, inject, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FormGroup } from '@angular/forms';
import { RealEstateAgreementForm } from '../../shared-agreement.model';
import { CachedValuesService } from '@services/cached-values';
import { DropdownItem } from '@shared/components/dropdown/dropdown.component';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'app-agreement-real-estate',
    templateUrl: './real-estate.component.html',
    styleUrl: './real-estate.component.scss'
})
export class AgreementRealEstateComponent {
    @Input() public realEstateForm: FormGroup<RealEstateAgreementForm>;
    @Input() public showPotentialValidationMessages: boolean;
    private readonly cachedValuesService = inject(CachedValuesService);

    public typeOfPremisesList$: Observable<DropdownItem<string>[]>;

    public get f() {
        return this.realEstateForm.controls;
    }

    public get disabled() {
        return this.f.typeOfPremises.disabled;
    }

    public createTypeOfPremises() {
        throw new Error('Method not implemented.');
    }
}
